import { useState } from "react";

const lsTutorialSeenKey = "tutorialSeen";

/**
 * Tiene traccia del fatto che l'utente abbia già aperto almeno una volta il
 * tutorial dalla scala. Serve solo a decidere se evidenziare il pulsante di
 * aiuto: il tutorial non viene mai mostrato in automatico.
 */
export const useTutorialService = () => {
    const [isTutorialSeen, setIsTutorialSeen] = useState(
        () => localStorage.getItem(lsTutorialSeenKey) === "true"
    );

    const markTutorialAsSeen = () => {
        localStorage.setItem(lsTutorialSeenKey, "true");
        setIsTutorialSeen(true);
    };

    return { isTutorialSeen, markTutorialAsSeen };
};
